



























































































import mixins from 'vue-typed-mixins';
import SmartTableBaseMixin from '@/mixins/SmartTable/SmartTableBaseMixin';
import LanguageMixin from '@/mixins/SmartTable/LanguageMixin';
import { Cell } from '@/models/SmartTable/Cell';
import { toDateString, toIntlDateString } from '@/models/SmartTable/Converters';
import _ from 'lodash';
import {
  dateTimeValueFromInputEvent as dateTimeValueFromInputEventInternal,
  displayValueForDateTimeInput as displayValueForDateTimeInputInternal
} from '@/models/SmartTable/DateTimeInput';

export default mixins(SmartTableBaseMixin, LanguageMixin).extend({
  props: {
    row: Object,
    cell: Object,
    readonly: { type: Boolean, default: false },
    translation: { type: Object, required: true }
  },
  data: function () {
    return {
      model: {} as Cell,
      isNavigating: false
    };
  },
  created: function () {
    this.model = _.cloneDeep(this.cell);
  },
  mounted() {
    if (this.isEditing === false) {
      this.startEditing();
    }
  },
  computed: {
    isEditing: function (): boolean {
      return this.model.isEditing;
    }
  },
  watch: {
    isEditing: function (value) {
      if (value === true) {
        this.$nextTick(() => {
          const inputField = this.$refs.editor as HTMLInputElement;
          if (!inputField) {
            return;
          }
          inputField.focus({ preventScroll: true });
          if (inputField.type === 'date') {
            this.model.value = toIntlDateString(this.model.value);
          }
          if (inputField.type === 'text' || inputField.type === 'number') {
            inputField.select();
          }
        });
      }
    }
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cellValue(cell: Cell, row: any) {
      if (cell.fieldType === 'boolean') {
        if (cell.value === true) {
          return '\u2713';
        } else if (cell.value === false) {
          return '\u2717';
        } else {
          return '';
        }
      } else if (cell.fieldType === 'date') {
        if (cell.value) {
          return toDateString(cell.value);
        } else {
          return cell.value;
        }
      } else if (cell.fieldType === 'datetime-local') {
        return cell.converter(cell.value, row);
      } else if (cell.fieldType === 'dropdown') {
        const dropdownOption = cell.dropdownOptions.find((x) => x.id === cell.value);
        if (dropdownOption) {
          return cell.converter(dropdownOption.title, row);
        } else {
          return '';
        }
      } else {
        return cell.converter(cell.value, row);
      }
    },
    unselectCell: function () {
      if (this.isNavigating === false) {
        this.$emit('unselect-cell');
      }
    },
    startEditing: function () {
      this.isNavigating = false;
      if (!!this.model && this.model.editable(this.row) === true && this.readonly === false) {
        this.model.isEditing = true;
      }
    },
    stopEditing: function (
      continuation: () => void = () => {
        // This is intentional
      }
    ) {
      if (this.isNavigating === false) {
        this.isNavigating = true;

        let oldValue;
        const newValue = this.model.value;

        if (this.cell.fieldType === 'date') {
          oldValue = toIntlDateString(this.row[this.cell.fieldName]);
        } else {
          oldValue = this.row[this.cell.fieldName];
        }

        if (oldValue === newValue) {
          this.cancel();
          continuation();
        } else {
          if (this.validate(this.$refs.editor as HTMLInputElement) === true) {
            this.update();
            continuation();
          } else {
            this.isNavigating = false;
          }
        }
      }
    },
    validate: function (input: HTMLInputElement) {
      if (!input) {
        return true;
      }
      let valid = true;
      const validationResult = this.cell.validate(this.model.value, this.row, false);
      if (!validationResult.isValid) {
        let validationMessage = validationResult.errorMessages.join('\n');
        if ((validationMessage.trim() || '').length == 0 && this.currentTranslation) {
          validationMessage = this.currentTranslation.invalidValue;
        }
        input.setCustomValidity(validationMessage);
        valid = false;
      } else {
        input.setCustomValidity('');
      }
      input.reportValidity();

      const formValid = this.validateFormOrElement(input) === true;
      return valid && formValid;
    },
    update: function () {
      this.row[this.cell.fieldName] = this.model.value;
      this.model.isEditing = false;
      this.$emit('updated', this.row);
    },
    cancel: function () {
      this.model = _.cloneDeep(this.cell);
      this.model.isEditing = false;
    },
    moveNextCol: function (shiftCount: number) {
      this.stopEditing(() => this.$emit('move-to-col', shiftCount));
    },
    moveNextRow: function (shiftCount: number) {
      this.stopEditing(() => this.$emit('move-next-row', shiftCount));
    },
    dateTimeValueFromInputEvent(inputEvent: Event): string | null {
      return dateTimeValueFromInputEventInternal(inputEvent);
    },
    displayValueForDateTimeInput(dateTimeValue: Date | null): string {
      return displayValueForDateTimeInputInternal(dateTimeValue);
    }
  }
});
